import React from 'react';
import { generateId, shortHandDate, translate } from '../../utility/functions';
import Table from '../../table/Table';
import Button from '../../forms/Button';
import GetState from '../../GetState';
import { QuestRoute } from '../../api/QuestRoutes';
import HamQuest from '../../api/HamQuestGiver';
import Form from '../../forms/Form';
import Input from '../../forms/Input';
import Preput from '../../forms/Preput';
import Select from '../../forms/Select';
import { HSOptions } from '../../../constants/HSOptions';
import Radio from '../../forms/Radio';
import AutoSelectAndUpgrade from '../../forms/formComponents/AutoSelectAndUpgrade';
import LocationSelectors from '../../forms/formComponents/LocationSelectors';
import TerminalIDsSelector from '../../forms/formComponents/TerminalIDsSelector';
import ImageIndex from '../../forms/formComponents/ImageIndex';
import ColorInput from '../../forms/formComponents/ColorInput';
import { userRoles } from '../../RoleProtected';
import ManagementRow from '../../table/ManagementRow';
import ModalFactory from '../../Modal';

const PromoCodes = ({ ...props }) => {

    const [promoCodes, refreshPromoCodes] = GetState(QuestRoute.mobile.promoCodes);

    const PromoCodeForm = ({ values, ...props }) => (
        <>
            <Input
                label='Promo Code'
                name='promoCode'
                required
            />
            <Input
                label='Name'
                name='dealName'
                required
            />
            <Select
                label='Award Type'
                name='awardType'
                options={HSOptions.expressPass.awardItemType}
                required
            />
            {(values.awardType === 'DollarDiscItem' || values.awardType === 'Item') && (
                <Radio
                    label='Item'
                    name='kioskItemId'
                    getOptions={QuestRoute.kiosks.wash}
                    buildOptions={e => {
                        e.label = e.name
                        e.value = e.id
                    }}
                    required
                />
            )}

            <Input
                label='Value'
                name='awardValue'
                type='price'
                disable={values.awardType === 'Item'}
                required
            />
            <Input
                label='Start Date'
                name='startDate'
                type='date'
            />
            <Input
                label='End Date'
                name='endDate'
                type='date'
            />
            <Input
                label='Claim Limit'
                name='claimLimit'
                type='number'
            />

            <Select
                label='Expiration Type'
                name='expirationType'
                options={HSOptions.expirationType}
                required
            />

            {
                values.expirationType === 'Custom' &&
                <Input
                    label='Expires in (Days)'
                    name='expires'
                    type='number'
                />
            }
            {
                values.expirationType === 'Date' &&
                <Input
                    label='Expires in'
                    name='expirationDate'
                    type='date'
                />
            }

            <AutoSelectAndUpgrade
                upgrades='allowUpgrades'
                select='autoSelect'
                values={values}
            />

            <ImageIndex />

            <ColorInput />

            <LocationSelectors />

            <TerminalIDsSelector />
        </>
    )


    const deleteDeal = (deal) => {
        ModalFactory.confirmAndProcess({
            confirmation: {
                title: `Are you sure?`,
                body: `Are you sure you want to delete ${deal.dealName}?`,
                type: 'warning',
            },
            promise: {
                title: 'Deleting Deal',
                body: `Deleting ${deal.dealName}`,
                callback: () => HamQuest.delete(QuestRoute.mobile.editPromoCodes(deal.dealId))
            },
            confirmed: {
                title: 'Success',
                body: `${deal.dealName} successfully deleted.`,
                type: 'success'
            },
            finally: () => refreshPromoCodes()
        })
    }

    const editDeal = (deal) => {
        // console.log(deal)
        const id = generateId();
        ModalFactory.show({
            id,
            title: `Edit ${deal.dealName}`,
            body: (
                <Form
                    inputs={{ ...deal }}
                    onSubmit={e => HamQuest.put(QuestRoute.mobile.editPromoCodes(e.dealId), { ...e })
                        .then(() => {
                            refreshPromoCodes();
                            ModalFactory.close(id);
                        })
                    }
                    text='Update'
                >
                    {({ values }) => <PromoCodeForm values={values} />}
                </Form>
            )
        })
    }

    const addNewPromo = () => {
        const id = generateId();
        ModalFactory.show({
            id,
            title: `Add a new Promo`,
            body: (
                <Form
                    inputs={{
                        dealName: '',
                        details: '',
                        terms: '',
                        awardType: '',
                        awardValue: '',
                        startDate: '',
                        endDate: '',
                        claimLimit: '',
                        expirationType: '',
                        expires: '',
                        expirationDate: '',
                        kioskItemId: '',
                        allowUpgrades: '',
                        autoSelect: '',
                        logoColor: '',
                        logoImageIndex: '',
                        locations: [],
                        terminalIds: [],
                    }}
                    onSubmit={e => HamQuest.post(QuestRoute.mobile.promoCodes, { ...e })
                        .then(() => {
                            refreshPromoCodes();
                            ModalFactory.close(id);
                        })
                    }
                    text='Add'
                >
                    {({ values }) => <PromoCodeForm values={values} />}
                </Form>
            )
        })
    }

    return (

        <Table
            config={{
                label: 'Promo Code',
                controls: [<Button roles={userRoles.editProducts} onClick={addNewPromo}>Add New Promo</Button>],
                data: promoCodes,
                headers: [
                    {
                        label: 'Promo Code',
                        propKey: 'promoCode',
                    }, {
                        label: 'Award Name',
                        propKey: 'dealName',
                    }, {
                        label: 'Award Type',
                        propKey: 'awardType',
                        options: true,
                    }, {
                        label: 'Start Date',
                        propKey: 'startDate',
                    }, {
                        label: 'End Date',
                        propKey: 'endDate',
                    },
                ],
                renderFormat: (e) => (
                    <ManagementRow
                        key={generateId()}
                        controls={[
                            <Button roles={userRoles.editProducts} key={generateId()} onClick={() => editDeal(e)}>Edit</Button>,
                            <Button roles={userRoles.editProducts} key={generateId()} onClick={() => deleteDeal(e)}>Delete</Button>
                        ]}
                    >
                        <td>{e.promoCode}</td>
                        <td>{e.dealName}</td>
                        <td>{translate(e.awardType)}</td>
                        <td>{shortHandDate(e.startDate)}</td>
                        <td>{shortHandDate(e.endDate)}</td>
                    </ManagementRow>
                )
            }}
        />
    );
}

export default PromoCodes;